import PropTypes from 'prop-types';
import { Button, Stack } from '@mui/material';

import { ACTION_MENU_BUTTON_TYPE, componentsSize } from 'constants/components';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import { ActionsMenu } from 'components/simple';

const ACTION_MENU_BUTTON_PROPS = {
  type: ACTION_MENU_BUTTON_TYPE.ICON,
  size: componentsSize.large,
  colored: true,
};

export const ProjectActionButtons = ({ actionsButtons, withActionsMenu, actionsMenuProps }) => {
  const { isSmUp } = useBreakpointFlags();

  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      flex="none"
      width={isSmUp ? 'unset' : '100%'}
    >
      {actionsButtons.map(
        ({ label, show, id, ...buttonProps }) =>
          show && (
            <Button fullWidth={!isSmUp} key={id} id={id} {...buttonProps}>
              {label}
            </Button>
          ),
      )}

      {withActionsMenu && <ActionsMenu {...actionsMenuProps} buttonProps={ACTION_MENU_BUTTON_PROPS} />}
    </Stack>
  );
};

ProjectActionButtons.propTypes = {
  actionsButtons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      show: PropTypes.bool.isRequired,
      color: PropTypes.string,
      type: PropTypes.string,
      loading: PropTypes.bool,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  withActionsMenu: PropTypes.bool.isRequired,
  actionsMenuProps: PropTypes.shape({
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.node,
        onClick: PropTypes.func,
        link: PropTypes.string,
        hideOption: PropTypes.bool,
      }),
    ).isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
};
